import React from "react";

function ExitButton(props) {
    const { alertExitApp } = props;

    const handleClick = () => {
        alertExitApp();
    };

    return (
        <li className="fl display_btn5" onClick={handleClick}>
            <button type="button" className="exit" />
        </li>
    );
}

export default ExitButton;
